import { render, staticRenderFns } from "./LearningActivities.vue?vue&type=template&id=a8dbb100&scoped=true&"
import script from "./LearningActivities.vue?vue&type=script&lang=js&"
export * from "./LearningActivities.vue?vue&type=script&lang=js&"
import style0 from "./LearningActivities.vue?vue&type=style&index=0&id=a8dbb100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dbb100",
  null
  
)

export default component.exports